const radii = {
  none: '0',
  sm: '0.125rem',
  base: '0.25rem',
  md: '0.5rem',
  lg: '0.75rem',
  full: '9999px',
}

export default radii
